import {addDays, subDays} from 'date-fns';

import {isNotNil} from 'ramda';

import {DataQueryOptions} from '@dms/shared';

import {buildObject, getApiDateString, Nullish} from 'shared/web';

import {LastUpdated} from '../types/LastUpdated';
import {ScheduledDaysPeriod} from '../types/ScheduledDaysPeriod';

export type KanbanStates = {
  lastUpdated: LastUpdated | Nullish;
  scheduledRentDaysPeriod: ScheduledDaysPeriod | Nullish;
  scheduledReturnDaysPeriod: ScheduledDaysPeriod | Nullish;
};

type GridFilters = Partial<{
  updatedAt: {relativeInputKey: 'LAST_N_DAYS'; relativeInputValue: number};
  scheduledRent: {from: string; to: string};
  scheduledReturn: {from: string; to: string};
}>;

export const getGridFiltersFromFiltersState = (states: KanbanStates): DataQueryOptions => ({
  filters: buildObject<GridFilters>()
    .updatedAt(
      {
        relativeInputKey: 'LAST_N_DAYS',
        relativeInputValue: states.lastUpdated ?? 0,
      },
      isNotNil(states.lastUpdated)
    )
    .scheduledRent(
      {
        from: getApiDateString(subDays(new Date(), states.scheduledRentDaysPeriod ?? 0)),
        to: getApiDateString(addDays(new Date(), states.scheduledRentDaysPeriod ?? 0)),
      },
      isNotNil(states.scheduledRentDaysPeriod)
    )
    .scheduledReturn(
      {
        from: getApiDateString(subDays(new Date(), states.scheduledReturnDaysPeriod ?? 0)),
        to: getApiDateString(addDays(new Date(), states.scheduledReturnDaysPeriod ?? 0)),
      },
      isNotNil(states.scheduledReturnDaysPeriod)
    )
    .build(),
});
